export default {
    name : 'wcAccountForm',

    init()
    {
        const el = document.getElementById('wcAccountForm');
        const vueData = (typeof window['register'] === 'object') ? window['register'] : null;
        if (el && vueData) {
            this.run(vueData);
        }
    },

    run (vueData)
    {
        const defaultData = {
            'validationMessages' : [],
            'confirmPassword'   :  '',
            'addShippingAddress' : 0,
            'modalBoxToggled' : 0,
            'showPasswortHint' : false
        };

        vueData = {...vueData, ...defaultData};

        // const vueData = [vueData]
        window['wcAccountForm'] = new Vue({
            el: '#wcAccountForm',

            delimiters: ['@{','}'],

            data : vueData,

            computed :
            {
                modalBoxClass ()
                {
                    return (this.modalBoxToggled) ? ' active ' : '';
                }
            },

            methods:
            {
                toggleShippingFields()
                {
                    this.addShippingAddress = (this.addShippingAddress) ? 0 : 1;
                    this.blurFields(true);
                },

                maybeHideShippingFields()
                {
                    if (!this.shipping_zipcode && !this.shipping_city && !this.shipping_postcode) {
                        this.addShippingAddress = 0;
                    }
                },

                shippingFieldsVisible()
                {
                    return (this.addShippingAddress===1 || this.shipping_address || this.shipping_city || this.shipping_zipcode);
                },

                getCompanyInfo()
                {
                    this.orgNumber = this.orgNumber.replaceAll(' ', '');
                    // this.orgNumber = '971593385';

                    if (this.orgNumber) {
                        axios.get(`https://data.brreg.no/enhetsregisteret/api/enheter/${this.orgNumber}`)
                          .then(this.getCompanyInfo__callback)
                          .catch(function (error) {
                            // handle error
                            console.log(error);
                        });
                    }
                },

                getCompanyInfo__callback(response)
                {
                    // _log('getCompanyInfo__callback');
                    // _log(response);
                    if (typeof response.data === 'object') {
                        this.companyName    = response.data.navn;
                        this.address        = response.data.forretningsadresse.adresse[0];
                        this.zipcode        = response.data.forretningsadresse.postnummer;
                        this.city           = response.data.forretningsadresse.poststed;
                        this.blurFields(true);
                    }
                },

                onSubmit (event)
                {
                    // _log('onSubmit');

                    if (!this.isFormValid()) {
                        event.preventDefault();
                        scrollTo('content');
                    }
                },

                isFormValid()
                {
                    let submitForm = true;

                    // reset validation
                    this.validationMessages = [];
                    document.querySelectorAll('.wc-validate').forEach((el) => el.classList.remove('validation-error'));

                    // validate passwords
                    if (!this.isPasswordStrength()) {
                        submitForm = false;
                        this.addValidationError('[data-password]');
                        this.validationMessages.push('Vennligst skriv inn et sterkere passord');
                    }

                    if (this.confirmPassword !== this.password) {
                        // _log('error')
                        submitForm = false;
                        this.addValidationError('[data-password]');
                        this.validationMessages.push('Passordene må være like');
                    }

                    return submitForm;
                },

                isPasswordStrength()
                {
                    const strength = wp.passwordStrength.meter(this.password, wp.passwordStrength.userInputDisallowedList());

                    return (strength >= 2) ? true : false;
                },

                validateStrength()
                {
                    this.showPasswortHint = false;
                    if (typeof this.password === 'string' && this.password.length) {
                        if (!this.isPasswordStrength()) {
                            this.showPasswortHint = true;
                        }
                    }
                },

                toggleLabel(event)
                {
                    // _log(event.target);
                    const el = event.target;
                    const formRow = el.closest(".woocommerce-form-field");
                    formRow.classList.add('active');
                },

                blurFields( timeout=false )
                {
                    if (timeout) {
                        setTimeout(this.runBlur, 200);
                    } else {
                        this.runBlur();
                    }
                },

                runBlur()
                {
                    const fields = document.querySelectorAll(".woocommerce-form-field input");

                    fields.forEach((field) => {
                            let formRow = field.closest(".woocommerce-form-field");
                            if (!field.value && field !== document.activeElement && field.type!=='password' && field.type!=='checkbox' && field.type!=='hidden') {
                                formRow.classList.remove('active');
                            } else {
                                formRow.classList.add('active');
                            }
                        }
                    );
                },

                addValidationError( selector )
                {
                    document.querySelectorAll(selector).forEach((el) => el.classList.add('validation-error'));
                },

                toggleModalBox ()
                {
                    this.modalBoxToggled = (this.modalBoxToggled) ? 0 : 1;
                }
            },

            created ()
            {
                this.blurFields(true);
                this.isReady = ' isReady ';
            }
      }); // close vue app

    }, // close run
} // close class